import { getActiveCompany } from '../localstorage';

const useGetCurrency = () => {
  const _activeCompany = getActiveCompany();

  const listOfCompaniesIdsWithDollarCurrency = [
    // "Prove" company id
    '6046e9fe-9815-4ec2-914f-de3624155e79',
    // "Marvel" company id
    '1b3275fd-3a3b-4bb5-b4bf-d625fbc2717e',
    // "Dyna.ai" companu id,
    '49af5b77-9ef7-4837-8e4a-5e08d751fcf9',
    // "Monnai"
    'bba814a1-6c01-4feb-b218-38571c3aa04f',
    // "FIG Financial"
    'd96c56ab-d2f9-4165-be7f-28fd5640d2e7',
  ];

  if (listOfCompaniesIdsWithDollarCurrency.find((companyId) => companyId === _activeCompany?.id)) {
    return '$';
  }
  return '€';
};

export default useGetCurrency;
